<script setup>
import {
  VueSpinner,
} from 'vue3-spinners';
// Add any required setup script here
</script>


<template>
  <div class="overlay">
      <VueSpinner size="120" color="white" />
  </div>
</template>
  

<style scoped>
.overlay {
    position: fixed;
    /* Fixed position to cover the entire screen */
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    /* Semi-transparent black background */
    display: flex;
    justify-content: center;
    /* Center horizontally */
    align-items: center;
    /* Center vertically */
    z-index: 9999;
    /* High z-index to be above other content */
    pointer-events: none;
    /* Prevent interaction with underlying elements */
}

.overlay>* {
    pointer-events: auto;
    /* Allow interactions with the spinner */
}</style>